import { withStyles } from '@material-ui/core/styles'
import React from 'react'
import DropZoneArea from '../../DropZoneArea'
import styles from '../../styles'
import Template from './One_City_Basic_Tracking_Internal_Code_upload_template.csv'

const Body = ({ classes, error, onFileUpload, setError, setFile }) => {
  return (
    <div className={classes.body}>
      <div className={classes.textContent}>
        <div className={classes.popupInfo}>
          Upload a file in format .csv with the required information. You can
          find a template for this campaign here:{' '}
          <a className={classes.downloadButton} href={Template} download>
            download template
          </a>
        </div>
        <div className={classes.popupTextBlock}>
          <div className={classes.subheader}>The file should contain:</div>
          <ul>
            <li>Unique codes, one per mission.</li>
          </ul>
        </div>
        <div className={classes.popupTextBlock}>
          The code can not be longer than 12 characters.
        </div>
        <div className={classes.popupTip}>
          You can make changes after you've uploaded a file by uploading another
          file. The new data will replace the previously uploaded data.
        </div>
      </div>
      <DropZoneArea
        onFileUpload={onFileUpload}
        error={error}
        setFile={setFile}
        setError={setError}
      />
    </div>
  )
}
export default withStyles(styles)(Body)
